import { takeLatest, call, put, all } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import {
  setExpenseList,
  setSearchFields,
  setExpenseDisputeReason,
  setExpenseDetails,
  setAllSavedColumn,
} from '../actions/expenseAction';
import * as SnackbarAction from '../actions/snackbarAction';
import { setLoader } from '../actions/loaderAction';
import history from '../utils/history';

function* expense(action) {
  try {
    const response = yield call(
      callApi,
      URLS[action.url],
      'GET',
      action.payload,
      false,
      action.hasRole,
    );
    yield put(
      setExpenseList(
        response.res_data,
        action.key,
        action.filterQuery
      ),
    );
    yield put(setLoader(false));
    let { location } = history;
    if (location?.search && location.search.includes('&Count')) {
      let filter = location.search.split('=')[1].split('&')[0];
      if (response?.res_data?.count > 0) {
        history.replace(`${location.pathname}?tab=${filter}`);
      } else {
        history.replace(`${location.pathname}?tab=All`);
        if (action.callBack) {
          yield put(action.callBack);
        }
      }
    }
    if (action.fromRefresh) {
      yield put(
        SnackbarAction.openSnackbar({
          message: 'Table refreshed successfully.',
          type: 'success',
        }),
      );
    }
    // const resDATHLJSKDK = yield call(callApi, URLS.TYPEHEAD, 'GET', {query: 'ban'});
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: response.res_str,
    //     type: 'success',
    //   }),
    // );
  } catch (error) {
    // yield put(setExpenseList([]));
    let tempRes = { count: 0, data: [] };
    yield put(setExpenseList(tempRes, action.key));
    yield put(
      SnackbarAction.openSnackbar({
        message: action.fromRefresh ? 'Table refresh failed. Please try again' : error.data?.res_str,
        type: 'error',
      }),
    );
  }
}
function* expenseSearchFields(action) {
  try {
    const response = yield call(
      callApi,
      URLS.GET_SEARCH_FIELDS,
      'GET',
      action.payload,
    );
    yield put(setSearchFields(response.res_data));
    yield put(setLoader(false));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: response.res_str,
    //     type: 'success',
    //   }),
    // );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* setExpenseDispute(action) {
  try {
    const response = yield call(
      callApi,
      URLS.DISPUTE_EXPENSE,
      'POST',
      action.payload,
      true,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
    if (action.callBack) {
      yield put(action.callBack);
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* GetExpenseDisputeReason(action) {
  try {
    const response = yield call(
      callApi,
      URLS.DISPUTE_REASONS,
      'GET',
      action.payload,
    );
    yield put(setExpenseDisputeReason(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* expenseDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.GET_SINGLE_TRANSACTION,
      'GET',
      action.payload,
    );
    yield put(setExpenseDetails(response.res_data));
  } catch (error) {
    // console.log('error',error)
    let obj = {};
    if (error && error.status === 404) {
      obj = {
        transaction: {
          dispute: {
            errorStr: 'You are not authorized for this.',
          },
        },
      };
    } else {
      obj = {
        transaction: {
          dispute: { errorStr: error.data.res_str },
        },
      };
    }
    yield put(setExpenseDetails(obj));
  }
}

function* disputeWithdrawexpense(action) {
  try {
    const response = yield call(
      callApi,
      URLS.DISPUTE_WITHDRAW,
      'POST',
      action.payloadDispute,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
    if (action.callBack) {
      yield put(action.callBack);
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* getGlobalSearchData(action) {
  try {
    const response = yield call(
      callApi,
      URLS[action.url],
      'GET',
      action.payload,
      false,
      action.hasRole,
    );
    yield put(setExpenseList(response.res_data, action.key));
    yield put(setLoader(false));
    // const resDATHLJSKDK = yield call(callApi, URLS.TYPEHEAD, 'GET', {query: 'ban'});
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: response.res_str,
    //     type: 'success',
    //   }),
    // );
  } catch (error) {
    // yield put(setExpenseList([]));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
    yield put(setLoader(false));
  }
}

function* deleteInvoiceVendor(action) {
  try {
    const response = yield call(
      callApi,
      URLS[action.url],
      'POST',
      action.payload,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
    if (action.callBack) {
      yield put(action.callBack);
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}

function* getAllSavedColumn(action) {
  try {
    const response = yield call(
      callApi,
      URLS.TABLE_COLUMN,
      'GET',
      action.payload,
    );
    yield put(setAllSavedColumn(response?.res_data?.cols || []));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}

function* postAllSavedColumn(action) {
  try {
    const response = yield call(
      callApi,
      URLS.TABLE_COLUMN,
      'POST',
      action.payload,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data?.res_str,
        type: 'error',
      }),
    );
  }
}

export function* expenseSaga() {
  yield takeLatest('SEARCH', expense);
  yield takeLatest('SEARCHFIELDS', expenseSearchFields);
  yield takeLatest('SET_DISPUTE', setExpenseDispute);
  yield takeLatest('GET_DISPUTE_REASON', GetExpenseDisputeReason);
  yield takeLatest('GET_TRANSACTION', expenseDetails);
  yield takeLatest('TXN_DISPUTE_WITHDRAW', disputeWithdrawexpense);
  yield takeLatest('GLOBAL_SEARCH', getGlobalSearchData);
  yield takeLatest('DELETE_INV_VEN', deleteInvoiceVendor);
  yield takeLatest('GET_COLUMN', getAllSavedColumn);
  yield takeLatest('POST_COLUMN', postAllSavedColumn);
}
